export default {
  applies_to_articles: "Gilt für folgende Artikel",
};
